// extracted by mini-css-extract-plugin
export default {"statCard":"StatCard_statCard__uxgoz","cardText":"StatCard_cardText__xP0uQ"};